export default __webpack_public_path__ + "static/media/alerts_icon.4b1e113c.svg";